import moment from 'moment'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import { useFinancialWorkspace } from 'modules/finance/components/FinancialWorkspace/Providers/Provider'
import { parseFormattedDateLabel } from 'modules/finance/components/FinancialWorkspace/lib/datePeriod'

export const useLabels = (comparison = false): string[] => {
  const {
    formattedState: {
      formattedStartDate,
      formattedEndDate,
      formattedCompareToStartDate,
      formattedCompareToEndDate,
    },
  } = useFinancialWorkspace()

  return useUnsafeMemo(() => {
    const labels: string[] = []
    const start = comparison ? moment(formattedCompareToStartDate) : moment(formattedStartDate)
    const end = comparison ? moment(formattedCompareToEndDate) : moment(formattedEndDate)

    const monthDiff = end.diff(start, 'months') + 1

    Array.from({ length: monthDiff }, (_, i) => {
      const date = moment(start).add(i, 'months')
      labels.push(parseFormattedDateLabel(date.format('MMM')))
    })

    return labels
  }, [
    comparison,
    formattedEndDate,
    formattedStartDate,
    formattedCompareToEndDate,
    formattedCompareToStartDate,
  ])
}
